import axios from "axios";
import { base_url } from "../../../utils/baseUrl";
import { config } from "../../../utils/axiosconfig";

const getCirculars = async (token) => {
  const response = await axios.get(`${base_url}circulars/getCircular` ,{
    
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      }
  });
 
  return response.data;
  
};
const createCircular = async (values) => {
  const token = values.token;
  
  const response = await axios.post(
    `${base_url}circulars/addCircular`,
    values, // Pass form data directly
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );

  return response.data;
};
const updateCircular = async (values) => {
  
  const response = await axios.put(
    `${base_url}circulars/editCircular/${values.id}`,
    values.NewsData,
    config
  );

  return response.data;
};

const getCircular = async (id) => {
  const response = await axios.get(`${base_url}circulars/getById/${id}`);

  return response.data;
};

const deleteCircular = async (id) => {
  const response = await axios.delete(`${base_url}circulars/deleteCircular/${id}`);

  return response.data;
};
const CircularService = {
  getCirculars,
  createCircular,
  getCircular,
  updateCircular,
  deleteCircular,
};

export default CircularService;
